import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-gpt-four-one',
  templateUrl: './gpt-four-one.component.html',
  styleUrls: ['./gpt-four-one.component.scss']
})
export class GptFourOneComponent {
  constructor(public dialogRef: MatDialogRef<GptFourOneComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
